import React from "react"
import {graphql, useStaticQuery} from "gatsby";
import Widget from "../Widget/widget";

const WidgetBanks = () => {

    const myQuery = useStaticQuery(query);
    const branch = myQuery.site.siteMetadata.config.branch;
    const config = require("../../../build/config/" + branch + ".json");
    const textStatic = require('../../../content/' + config.country + '/static-text.json');
    return (
        <Widget list={config.widget_bank_list} title={textStatic.widget_bank_list_title}/>
    )
};

export default WidgetBanks;

const query = graphql`
  query {
    site {
      siteMetadata {
        config {
          branch
        }
      }
    }
  }
`;